/**
 * fancyboxGallery Component
 *
 * @file slider.js
 */

import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel, Scrollbar } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel, Scrollbar]);

import 'swiper/swiper-bundle.css';


const fancyboxGallery = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const defaultFancybox = () => {
    Fancybox.bind('[data-fancybox]', {
      // Custom options for all galleries
    }); 
    Fancybox.bind('.fancybox-pdf', {
        openEffect: 'elastic',
        closeEffect: 'elastic',
        autoSize: true,
        type: 'iframe',
        iframe: {
            preload: false // fixes issue with iframe and IE
        }
    });
    Fancybox.bind('[data-fancybox="home-video-gallery"]', {
      // Custom options for all galleries
      Thumbs:false
    }); 
    $('.cookie-accept').on('click', function(){
      Fancybox.close();
    });  
  };

  const init = () => {
    defaultFancybox();
  };

  return {
    init,
  };
})();

export default fancyboxGallery;